import { render } from "./UserCoupons.vue?vue&type=template&id=a706f8ce"
import script from "./UserCoupons.vue?vue&type=script&lang=js"
export * from "./UserCoupons.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__